import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { logout } from "redux/actions/userActions";
import { TERMINATE_TOKEN } from "components/common/CONSTANTS";
import { SOMS_API_KEY } from "services/CONSTANTS";
import { postTokenSession } from "services/loginService";
import { encryptRequest } from "components/common/EncryptDecrypt";
import { useNavigate } from "react-router-dom";
import { clearLocations } from "redux/actions/locationActions";
import jwt_decode from "jwt-decode";
import { BroadcastChannel } from 'broadcast-channel';
const logoutChannel = new BroadcastChannel('logout');

export default function CommonDialog(props) {
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isShowing, title, content, onClick, onClose, onCancel, button1, button2, timer } = props;
  const [isShowingPopup, setIsShowingPopup] = React.useState(true);
  const autoLogout = async() => {
    dispatch(clearLocations())
    const token = sessionStorage.getItem("token")

    if (token !== "" && token !== null) {
      const credentials = jwt_decode(token);
      const finalReq = {
        "tokenType": TERMINATE_TOKEN,
        "accessToken": "",
        "expiresIn": "",
        "refreshToken": sessionStorage.getItem("refreshToken"),
        "scope": "",
        "userType": "",
        "empId": "",
        "primaryEmailAddress": credentials.email,
        "roleCode": "",
        "roles": "",
      }
      const request1 = await encryptRequest(finalReq)

      const request = {
        apikey: SOMS_API_KEY,
        params: { 
          token: request1
         },
         userId: credentials.email
      }
      postTokenSession(request).then(res => {
        logoutChannel.postMessage("Logout")
        dispatch(logout());
        localStorage.clear();
        sessionStorage.clear();
        setIsShowingPopup(false);
        window.location.reload();
        navigate("/");
        
      }).catch(error => {
        console.log(error)
      })
    }
  }
  if (timer === -1) {
    autoLogout();
  }
  return (

    <div>
       {isShowingPopup ? (
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={isShowing}
        onClose={onCancel}
        aria-labelledby="title"
        aria-describedby="description"
      >
        <DialogTitle id="title">
          {title}
          <IconButton
            aria-label="close"
            onClick={onCancel}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="description">{content}</DialogContentText>
        </DialogContent>

        <DialogActions sx={{ pl: 3, pb: 3, justifyContent: "flex-start" }}>
          <Button variant="contained"  sx={{"&:hover": { backgroundColor: "#009B6D" },backgroundColor:"#009B6D"}}  onClick={onClose}>
            {button2}
          </Button>
          <Button variant="contained" sx={{"&:hover": { backgroundColor: "#004E37" },backgroundColor:"#004E37"}}  onClick={onClick}>
            {button1}
          </Button>
        </DialogActions>
      </Dialog>  ) : (
          ""
        )}
    </div>
  );
}
